import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import {
  ReportTemplate,
  ReportTemplateFilterOption,
  ReportTemplateStatus,
} from 'dashboard/models/report-template';
import Action from 'lib/interfaces/Action';
import { PaginationParams } from 'lib/interfaces/api';
import { Iso8601DateString } from 'lib/types';

export type ReportTemplatesActions =
  | Action<ReportTemplatesActionType.SetReportTemplates, SetReportTemplatesPayload>
  | Action<ReportTemplatesActionType.SetCurrentPage, SetCurrentPagePayload>
  | Action<ReportTemplatesActionType.SetPageSize, SetPageSizePayload>
  | Action<ReportTemplatesActionType.SetFilters, SetFiltersPayload>
  | Action<ReportTemplatesActionType.SetSortParams, SetSortParamsPayload>
  | Action<ReportTemplatesActionType.SetFilterOptions, SetFiltersOptionsPayload>;

export enum ReportTemplatesActionType {
  SetReportTemplates = 'report-templates/SET_REPORT_TEMPLATES',
  SetCurrentPage = 'report-templates/SET_CURRENT_PAGE',
  SetPageSize = 'report-templates/SET_PAGE_SIZE',
  SetFilters = 'report-templates/SET_FILTERS',
  SetSortParams = 'report-templates/SET_SORT_PARAMS',
  SetFilterOptions = 'report-templates/SET_FILTER_OPTIONS',
}

interface SetReportTemplatesPayload {
  reportTemplates: ReportTemplate[];
  paginationParams: PaginationParams;
}

interface SetFiltersOptionsPayload {
  filterOptions: ReportTemplateFilterOption[];
}

export function setReportTemplates(
  reportTemplates: ReportTemplate[],
  paginationParams: PaginationParams,
): Action<ReportTemplatesActionType.SetReportTemplates, SetReportTemplatesPayload> {
  return {
    payload: {
      reportTemplates,
      paginationParams,
    },
    type: ReportTemplatesActionType.SetReportTemplates,
  };
}
interface SetCurrentPagePayload {
  currentPage: number;
}

export function setCurrentPage(
  currentPage: number,
): Action<ReportTemplatesActionType.SetCurrentPage, SetCurrentPagePayload> {
  return {
    payload: {
      currentPage,
    },
    type: ReportTemplatesActionType.SetCurrentPage,
  };
}

interface SetPageSizePayload {
  pageSize: number;
}

export function setPageSize(
  pageSize: number,
): Action<ReportTemplatesActionType.SetPageSize, SetPageSizePayload> {
  return {
    payload: {
      pageSize,
    },
    type: ReportTemplatesActionType.SetPageSize,
  };
}

export interface ReportTemplatesFilterParams {
  createdAtStart?: Iso8601DateString;
  createdAtEnd?: Iso8601DateString;
  accountId?: string;
  type?: ReportTemplate['type'][];
  omni?: string;
  status?: ReportTemplateStatus[];
}

interface SetFiltersPayload {
  filters: ReportTemplatesFilterParams;
}

export function setFilters(
  filters: ReportTemplatesFilterParams,
): Action<ReportTemplatesActionType.SetFilters, SetFiltersPayload> {
  return {
    payload: {
      filters,
    },
    type: ReportTemplatesActionType.SetFilters,
  };
}

interface SetSortParamsPayload {
  sortParams: SortParams;
}

export function setSortParams(
  sortParams: SortParams,
): Action<ReportTemplatesActionType.SetSortParams, SetSortParamsPayload> {
  return {
    payload: {
      sortParams,
    },
    type: ReportTemplatesActionType.SetSortParams,
  };
}

export function setReportTemplateFilterOptions(
  filterOptions: SetFiltersOptionsPayload['filterOptions'],
): Action<ReportTemplatesActionType.SetFilterOptions, SetFiltersOptionsPayload> {
  return {
    payload: {
      filterOptions,
    },
    type: ReportTemplatesActionType.SetFilterOptions,
  };
}
